var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService02(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.5974,
    height: 79.5974,
    rx: 39.7987,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5645 41.2747L48.0768 55.4131C48.1049 55.5796 48.0816 55.7507 48.0098 55.9036C47.9381 56.0564 47.8214 56.1837 47.6754 56.2685C47.5293 56.3532 47.3609 56.3914 47.1926 56.3778C47.0243 56.3642 46.8642 56.2996 46.7336 56.1925L40.797 51.7367C40.5104 51.5226 40.1622 51.4069 39.8045 51.4069C39.4467 51.4069 39.0986 51.5226 38.812 51.7367L32.8654 56.1909C32.7349 56.2977 32.575 56.3623 32.4069 56.3758C32.2388 56.3894 32.0705 56.3514 31.9246 56.2669C31.7787 56.1824 31.662 56.0554 31.5901 55.9029C31.5182 55.7503 31.4945 55.5795 31.5222 55.4131L34.0328 41.2747",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7987 43.1154C45.2937 43.1154 49.7484 38.6608 49.7484 33.1657C49.7484 27.6707 45.2937 23.2161 39.7987 23.2161C34.3036 23.2161 29.849 27.6707 29.849 33.1657C29.849 38.6608 34.3036 43.1154 39.7987 43.1154Z",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService02);
export default __webpack_public_path__ + "static/media/service02.b55afd6128b5b95fe1cdee9fca555441.svg";
export { ForwardRef as ReactComponent };